var _path, _g, _g2, _circle, _g3, _g4, _circle2, _path2, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 156 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_58_12232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 10,
    width: 131,
    height: 144
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.3666 11.6495C76.7914 10.2949 79.7453 10.2949 82.1701 11.6495L139.216 43.5191C141.746 44.9328 143.314 47.6046 143.314 50.5031V113.792C143.314 116.691 141.746 119.363 139.216 120.776L82.1701 152.646C79.7453 154 76.7914 154 74.3666 152.646L17.321 120.776C14.7906 119.363 13.2227 116.691 13.2227 113.792V50.5031C13.2227 47.6046 14.7906 44.9328 17.321 43.5191L74.3666 11.6495Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_58_12232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.924 32.265C159.373 41.8975 164.007 52.8476 166.337 64.6261L122.301 73.3378C122.858 76.1509 123.157 79.092 123.157 82.1474C123.157 85.2028 122.858 88.1439 122.301 90.9571L166.337 99.6688C164.007 111.447 159.373 122.397 152.924 132.03L115.623 107.057C112.332 111.971 108.092 116.212 103.177 119.502L128.15 156.804C118.518 163.253 107.568 167.887 95.7891 170.217L87.0774 126.181C84.2643 126.737 81.3232 127.036 78.2678 127.036C75.2124 127.036 72.2713 126.737 69.4581 126.181L60.7464 170.217C48.968 167.887 38.0179 163.253 28.3854 156.804L53.3585 119.502C48.4439 116.212 44.2032 111.971 40.913 107.057L3.61107 132.03C-2.83772 122.397 -7.47176 111.447 -9.80189 99.6688L34.2344 90.9571C33.6778 88.1439 33.379 85.2028 33.379 82.1474C33.379 79.092 33.6778 76.1509 34.2344 73.3378L-9.80189 64.6261C-7.47176 52.8476 -2.83772 41.8975 3.61106 32.2651L40.913 57.2381C44.2032 52.3235 48.4439 48.0829 53.3584 44.7926L28.3854 7.49071C38.0179 1.04192 48.9679 -3.59212 60.7464 -5.92225L69.4581 38.114C72.2713 37.5575 75.2124 37.2586 78.2678 37.2586C81.3232 37.2586 84.2643 37.5575 87.0774 38.114L95.7891 -5.92225C107.568 -3.59212 118.518 1.04192 128.15 7.4907L103.177 44.7926C108.092 48.0828 112.332 52.3235 115.623 57.2381L152.924 32.265Z",
    fill: "#00A3DC",
    stroke: "#00BADD",
    strokeWidth: 89.7794,
    strokeDasharray: "38.09 38.09"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_58_12232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.3666 11.6495C76.7914 10.2949 79.7453 10.2949 82.1701 11.6495L139.216 43.5191C141.746 44.9328 143.314 47.6046 143.314 50.5031V113.792C143.314 116.691 141.746 119.363 139.216 120.776L82.1701 152.646C79.7453 154 76.7914 154 74.3666 152.646L17.321 120.776C14.7906 119.363 13.2227 116.691 13.2227 113.792V50.5031C13.2227 47.6046 14.7906 44.9328 17.321 43.5191L74.3666 11.6495Z",
    stroke: "url(#paint0_linear_58_12232)",
    fillOpacity: 0,
    strokeWidth: 9
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.2684,
    cy: 82.1475,
    r: 43.1033,
    fill: "#004CDC"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_58_12232)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4038 58.0942C77.0803 58.1575 76.8156 58.2505 76.8156 58.3008C76.8156 58.3512 76.7618 58.3924 76.696 58.3924C76.3852 58.3924 75.2817 59.4121 74.9993 59.9603C74.92 60.1143 74.8273 60.2655 74.7935 60.2963C74.7597 60.3271 74.6662 60.6907 74.5859 61.1043C74.3023 62.5637 74.8876 63.9866 76.1433 64.8903C77.5071 65.8719 79.1494 65.8719 80.5132 64.8903C80.9996 64.5402 81.0616 64.4782 81.4119 63.9921C82.0405 63.1196 82.2899 62.0728 82.0823 61.1795C81.6912 59.4974 80.6746 58.4632 79.027 58.0714C78.4256 57.9284 78.238 57.931 77.4038 58.0942ZM64.6581 63.0516C63.9847 63.1489 62.6908 63.4776 61.9128 63.7491C61.2759 63.9714 59.8521 64.6793 59.8026 64.7983C59.782 64.8476 59.7156 64.888 59.655 64.888C59.5944 64.888 59.3591 65.0266 59.1321 65.196C58.7305 65.4957 58.6277 65.5768 58.2798 65.868C58.1878 65.945 58.0892 66.008 58.0607 66.008C57.9475 66.008 56.9731 67.0423 56.0871 68.1031C56.025 68.1775 55.9742 68.2867 55.9742 68.3457C55.9742 68.4049 55.9364 68.4699 55.8901 68.4905C55.6061 68.6166 54.8035 70.2063 54.3727 71.4957C53.6136 73.768 53.6211 73.6068 53.6211 87.7277C53.6211 99.8244 53.6524 101.186 53.9492 102.014C54.1177 102.484 54.693 103.594 54.907 103.862C55.805 104.987 57.2409 105.941 58.2387 106.074C58.4754 106.106 58.6958 106.175 58.7287 106.229C58.8127 106.365 60.8758 106.351 60.9604 106.214C60.9985 106.152 61.1492 106.102 61.2953 106.102C61.6727 106.102 62.8845 105.519 63.528 105.028C63.8283 104.798 64.6133 104.077 65.2723 103.424C65.9313 102.772 67.0282 101.717 67.7098 101.081C68.3914 100.445 69.7164 99.1725 70.6544 98.2534C71.5922 97.3343 72.3785 96.5822 72.4017 96.5822C72.4249 96.5822 73.1167 95.9144 73.9389 95.0983C75.7288 93.3218 78.1297 91.0525 78.2718 91.0029C78.3278 90.9834 78.7849 91.3614 79.2873 91.8429C79.7898 92.3245 80.4665 92.9704 80.791 93.2784C82.3642 94.7715 85.5126 97.8036 86.896 99.1581C87.7454 99.9896 89.0057 101.199 89.6966 101.846C90.3875 102.493 91.456 103.513 92.071 104.114C92.6861 104.714 93.2329 105.206 93.2861 105.206C93.3394 105.206 93.4497 105.271 93.5312 105.35C93.7624 105.575 94.5165 105.891 95.5861 106.21C96.082 106.358 97.5495 106.313 98.2733 106.127C98.7703 105.999 99.4751 105.74 99.5618 105.654C99.5926 105.623 99.7908 105.501 100.002 105.384C100.933 104.865 102.134 103.529 102.313 102.812C102.354 102.65 102.427 102.518 102.475 102.518C102.564 102.518 102.6 102.381 102.811 101.236C102.998 100.22 102.918 73.155 102.727 73.0916C102.65 73.0659 102.587 72.92 102.587 72.7673C102.587 72.513 102.357 71.6505 102.143 71.1037C101.932 70.5631 101.41 69.5325 101.33 69.4985C101.282 69.4779 101.243 69.3898 101.243 69.3028C101.243 69.1445 100.298 67.7593 99.927 67.3727C99.8187 67.2599 99.6006 67.0201 99.4426 66.8397C99.1991 66.562 98.875 66.2695 98.0258 65.5609C97.9514 65.4988 97.8379 65.448 97.7737 65.448C97.7095 65.448 97.657 65.4085 97.657 65.3602C97.657 65.3118 97.4932 65.1771 97.2928 65.0606C97.0925 64.9441 96.9034 64.8194 96.8726 64.7833C96.7779 64.6724 95.5889 64.1041 95.4517 64.1041C95.3807 64.1041 95.3058 64.0638 95.2852 64.0146C95.2396 63.9051 93.8662 63.4392 93.1749 63.2987C91.6284 62.9845 89.826 62.9059 88.5809 63.0983C88.2419 63.1507 87.7239 63.2287 87.4298 63.2717C87.1356 63.3146 86.868 63.3936 86.8349 63.447C86.8019 63.5004 86.6896 63.544 86.5854 63.5438C86.3368 63.5433 85.0523 64.0806 84.5213 64.407C84.2914 64.5484 84.0519 64.664 83.989 64.664C83.9262 64.664 83.8748 64.7036 83.8748 64.7518C83.8748 64.8002 83.7109 64.935 83.5106 65.0514C83.3102 65.1679 83.1212 65.295 83.0904 65.3341C83.0596 65.3731 82.9083 65.4911 82.7542 65.5964C82.4665 65.793 80.2459 67.8702 78.9918 69.1158C78.6041 69.5007 78.2545 69.8157 78.2147 69.8157C78.175 69.8157 77.4252 69.085 76.5487 68.1918C75.672 67.2987 74.9233 66.5679 74.8847 66.5679C74.8462 66.5679 74.6293 66.3933 74.4029 66.1799C74.1764 65.9664 73.8955 65.7614 73.7787 65.7243C73.6618 65.6872 73.5661 65.6178 73.5661 65.5701C73.5661 65.5224 73.3896 65.3883 73.1739 65.2722C72.9582 65.156 72.7817 65.0222 72.7817 64.9746C72.7817 64.927 72.7061 64.888 72.6137 64.888C72.5212 64.888 72.4456 64.8376 72.4456 64.776C72.4456 64.7144 72.3489 64.664 72.2308 64.664C72.1127 64.664 71.9993 64.6263 71.9787 64.58C71.9246 64.4583 71.2229 64.1041 71.0359 64.1041C70.9485 64.1041 70.8769 64.0595 70.8769 64.0052C70.8769 63.9508 70.7635 63.8793 70.6248 63.8464C70.4861 63.8133 70.1458 63.7009 69.8684 63.5964C68.9215 63.2396 68.0199 63.0924 66.5069 63.0477C65.6749 63.0231 64.843 63.0249 64.6581 63.0516ZM67.6704 66.4648C68.8435 66.7722 69.0855 66.8582 69.9525 67.2753C70.4608 67.5199 70.8769 67.7632 70.8769 67.816C70.8769 67.8687 70.9307 67.9119 70.9964 67.9119C71.1158 67.9119 71.7479 68.3536 72.1585 68.7238C72.278 68.8317 72.4165 68.9198 72.4662 68.9198C72.6342 68.9198 75.8157 72.2082 75.7832 72.3483C75.7494 72.4943 74.8437 73.5003 73.2019 75.2153C72.6628 75.7786 72.2215 76.2829 72.2215 76.3361C72.2215 76.3892 72.1187 76.543 71.993 76.6778C71.8674 76.8126 71.7359 77.0373 71.7008 77.1771C71.6657 77.317 71.592 77.4313 71.5371 77.4313C71.4821 77.4313 71.4371 77.522 71.4371 77.6329C71.4371 77.7438 71.392 77.8823 71.3369 77.9409C70.9698 78.3305 70.7902 81.5344 71.0785 82.5509C71.299 83.3283 71.8422 84.4022 72.2495 84.8659C72.3574 84.9886 72.4456 85.1261 72.4456 85.1712C72.4456 85.2768 73.1183 85.9468 74.6119 87.3285C75.2693 87.9368 75.8055 88.4911 75.8036 88.5605C75.8016 88.6299 75.4725 88.9891 75.0722 89.3586C74.6717 89.7282 73.501 90.8543 72.4705 91.8611C71.4399 92.868 70.2269 94.0271 69.7749 94.437C69.3229 94.8469 68.0042 96.1147 66.8446 97.2542C65.685 98.3937 64.2212 99.8048 63.5917 100.39C62.9622 100.975 62.2121 101.681 61.9248 101.958C61.1248 102.73 60.7653 102.891 59.8471 102.89C58.6419 102.889 57.8104 102.38 57.3098 101.338C57.0985 100.898 57.0937 100.54 57.1218 87.3391C57.149 74.591 57.1627 73.7551 57.3543 73.1756C57.4663 72.8368 57.5854 72.4209 57.6192 72.2516C57.6528 72.0822 57.7251 71.9436 57.7796 71.9436C57.8343 71.9436 57.879 71.8611 57.879 71.7601C57.879 71.483 59.0908 69.7162 59.6736 69.1438C60.7481 68.0884 61.0154 67.896 62.249 67.29C62.9752 66.9334 63.6961 66.6785 64.546 66.478C65.178 66.3289 67.1206 66.3208 67.6704 66.4648ZM92.2225 66.5067C92.469 66.548 92.7716 66.6233 92.8948 66.6738C93.0181 66.7244 93.4719 66.9079 93.9033 67.0816C94.3347 67.2553 94.7543 67.4629 94.8357 67.5427C94.9171 67.6226 95.0558 67.6879 95.1438 67.6879C95.2319 67.6879 95.3039 67.7383 95.3039 67.7999C95.3039 67.8615 95.367 67.9119 95.444 67.9119C95.5211 67.9119 95.7938 68.1009 96.0501 68.3318C96.3062 68.5629 96.6087 68.8303 96.7222 68.9262C97.1052 69.2497 97.99 70.3186 97.9916 70.4597C97.9925 70.5368 98.0435 70.5997 98.1052 70.5997C98.1668 70.5997 98.2172 70.6712 98.2172 70.7584C98.2172 70.8456 98.2612 70.9338 98.3149 70.9544C98.4332 70.9995 98.9664 72.1507 99.0702 72.5846C99.1111 72.7557 99.182 72.946 99.2278 73.0076C99.2736 73.0692 99.3504 73.3211 99.3982 73.5675C99.5344 74.2679 99.5851 100.859 99.4507 100.994C99.3886 101.056 99.3377 101.185 99.3377 101.281C99.3377 101.378 99.2117 101.592 99.0576 101.758C98.9035 101.924 98.7775 102.113 98.7775 102.177C98.7775 102.241 98.7018 102.294 98.6094 102.294C98.517 102.294 98.4413 102.337 98.4413 102.389C98.4413 102.515 97.701 102.823 97.2019 102.903C96.7389 102.978 95.6015 102.789 95.5467 102.628C95.5261 102.567 95.4596 102.518 95.3986 102.518C95.3378 102.518 95.2216 102.455 95.1403 102.378C95.0592 102.301 94.4271 101.709 93.7358 101.062C93.0444 100.415 91.7152 99.1375 90.7819 98.2226C89.8486 97.3076 88.5809 96.0917 87.9646 95.5206C87.3483 94.9495 85.9691 93.6191 84.8997 92.5643C83.8303 91.5096 82.9384 90.6466 82.9177 90.6466C82.8106 90.6466 80.8494 88.649 80.8494 88.5399C80.8494 88.4693 81.2615 88.0199 81.7652 87.5412C83.8213 85.5871 84.5925 84.7608 84.7121 84.3843C84.7529 84.256 84.8332 84.1509 84.8907 84.1509C84.9482 84.1509 84.9953 84.0849 84.9953 84.004C84.9953 83.9231 85.1023 83.6357 85.2331 83.365C85.3639 83.0944 85.4968 82.6805 85.5284 82.4453C85.5599 82.2101 85.6294 81.9907 85.6827 81.9578C85.8195 81.8732 85.8053 79.3643 85.6676 79.2792C85.6059 79.2411 85.5552 79.0492 85.5548 78.8526C85.5544 78.6561 85.4788 78.3509 85.3868 78.1745C85.2947 77.998 85.2194 77.7839 85.2194 77.6985C85.2194 77.6132 85.1689 77.5433 85.1073 77.5433C85.0457 77.5433 84.9953 77.4487 84.9953 77.333C84.9953 77.2174 84.9196 77.0601 84.8272 76.9833C84.7347 76.9066 84.6591 76.7745 84.6591 76.6897C84.6591 76.6048 84.6196 76.5354 84.5713 76.5354C84.5229 76.5354 84.4013 76.3965 84.301 76.2268C84.2006 76.057 83.3325 75.1241 82.3719 74.1536C81.4113 73.1829 80.6253 72.3496 80.6253 72.3016C80.6253 72.1817 81.2077 71.5836 82.2005 70.6841C82.6591 70.2687 83.5105 69.4748 84.0924 68.9202C84.6742 68.3657 85.2162 67.9119 85.2969 67.9119C85.3775 67.9119 85.4435 67.8694 85.4435 67.8174C85.4435 67.7656 85.6326 67.6271 85.8637 67.5095C86.0948 67.392 86.3091 67.2693 86.3399 67.2368C86.3707 67.2043 86.6228 67.0858 86.9001 66.9734C87.1774 66.8609 87.4919 66.7237 87.5989 66.6684C87.7059 66.6132 87.9328 66.5643 88.1031 66.5601C88.2734 66.5557 88.5136 66.5076 88.6369 66.4529C88.8798 66.3453 91.4936 66.3845 92.2225 66.5067ZM81.8576 78.6122C81.9501 78.7943 82.0629 78.971 82.1085 79.0051C82.2211 79.0889 82.4562 80.2076 82.4485 80.6231C82.4406 81.0451 82.1987 82.1713 82.0996 82.2467C82.0589 82.2777 81.9501 82.4496 81.8576 82.6287C81.7653 82.8078 81.2434 83.3874 80.6979 83.9166C80.1523 84.4459 79.4702 85.1095 79.182 85.3915C78.4037 86.1527 78.274 86.2037 77.937 85.881C76.1219 84.1438 74.8742 82.8608 74.7021 82.5545C74.4272 82.0654 74.1264 81.0221 74.1264 80.5578C74.1264 79.7853 74.6123 78.63 75.2058 77.9913C75.4635 77.7141 75.8578 77.2857 76.082 77.0393C76.3063 76.793 76.8782 76.1799 77.353 75.677L78.2162 74.7627L79.953 76.5219C80.9082 77.4894 81.7653 78.43 81.8576 78.6122ZM77.1517 102.679C76.2727 103.005 75.2469 103.762 75.2469 104.085C75.2469 104.147 75.1974 104.198 75.1369 104.198C75.0765 104.198 74.9954 104.324 74.9568 104.478C74.9181 104.632 74.8529 104.758 74.812 104.758C74.7711 104.758 74.6756 105.024 74.6 105.349C74.3489 106.428 73.9615 106.326 78.2803 106.326H82.0981L82.0191 105.682C81.9756 105.327 81.8964 105.021 81.8429 105C81.7895 104.98 81.7458 104.89 81.7458 104.8C81.7458 104.419 80.5527 103.078 80.2137 103.078C80.1319 103.078 80.065 103.035 80.065 102.983C80.065 102.804 78.9186 102.518 78.2313 102.526C77.8533 102.53 77.3674 102.599 77.1517 102.679Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_58_12232)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78.2684,
    cy: 82.1475,
    r: 43.1033,
    stroke: "url(#paint1_linear_58_12232)",
    strokeWidth: 7,
    fillOpacity: 0
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.2692,
    cy: 82.1481,
    r: 35.8669,
    stroke: "#EBEBF0",
    strokeWidth: 2,
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_58_12232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 140,
    height: 153
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3666 11.6495C76.7914 10.2949 79.7453 10.2949 82.1701 11.6495L139.216 43.5191C141.746 44.9328 143.314 47.6046 143.314 50.5031V113.792C143.314 116.691 141.746 119.363 139.216 120.776L82.1701 152.646C79.7453 154 76.7914 154 74.3666 152.646L17.321 120.776C14.7906 119.363 13.2227 116.691 13.2227 113.792V50.5031C13.2227 47.6046 14.7906 44.9328 17.321 43.5191L74.3666 11.6495Z",
    fill: "#D9D9D9",
    stroke: "#0078DC",
    strokeWidth: 9
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_58_12232)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -44.1875,
    y: 72.1204,
    width: 188.558,
    height: 88.6192,
    transform: "rotate(-43.6853 -44.1875 72.1204)",
    fill: "white",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_58_12232",
    x: 0.722656,
    y: 0.133545,
    width: 155.091,
    height: 168.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_58_12232"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_12232"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_58_12232",
    result: "effect2_dropShadow_58_12232"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_58_12232",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_58_12232",
    x: 49.6211,
    y: 54.9678,
    width: 57.2959,
    height: 56.3606,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_58_12232"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_12232"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_58_12232",
    result: "effect2_dropShadow_58_12232"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_58_12232",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_58_12232",
    x: 27.665,
    y: 32.5442,
    width: 101.207,
    height: 101.207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_58_12232"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_12232"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_58_12232",
    result: "effect2_dropShadow_58_12232"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_58_12232",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_12232",
    x1: 78.2683,
    y1: 154.826,
    x2: 78.2683,
    y2: 9.46973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#004CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0078DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#008EDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#00A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#00BADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#00D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#00DFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#00E3AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_12232",
    x1: 35.165,
    y1: 82.1475,
    x2: 121.372,
    y2: 82.1475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#004CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0078DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#008EDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#00A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#00BADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#00D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#00DFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#00E3AE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge3);
export default __webpack_public_path__ + "static/media/badge_3.44848be35c13f0581fdde97c12ec6e7d.svg";
export { ForwardRef as ReactComponent };